import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HomeComponent } from './home/home.component';
import { Routes, RouterModule } from '@angular/router';
import { HttpClientModule } from '@angular/common/http';
import {ConstantsService} from './common/services/constants.service';
import { StorageServiceModule} from 'angular-webstorage-service';
import {SessionsService} from './common/services/sessions.service';
import {UtilsService} from './common/services/utils.service';
import {HttpserviceService} from './common/services/httpservice.service';
import { HeaderComponent } from './header/header.component';
import { FooterComponent } from './footer/footer.component';
import { ReactiveFormsModule,FormsModule } from '@angular/forms';
import { DeviceDetectorModule } from 'ngx-device-detector';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { SellCarComponent } from './sell-car/sell-car.component';
import { VisitorComponent } from './visitor/visitor.component';
import { VisitorViewComponent } from './visitorview/visitor.component';
import { VisitorCantactusComponent } from './visitor-cantactus/visitor-cantactus.component';
import { HashLocationStrategy, LocationStrategy } from '@angular/common';
import { FixedPriceCarsComponent } from './fixed-price-cars/fixed-price-cars.component';
import { AuctionCarsComponent } from './auction-cars/auction-cars.component';
import { FixedPriceCarDetailComponent } from './fixed-price-car-detail/fixed-price-car-detail.component';
import { AuctionCarDetailComponent } from './auction-car-detail/auction-car-detail.component';
import { MyCarsComponent } from './my-cars/my-cars.component';
import {NgxImageCompressService} from 'ngx-image-compress';
import { MyProfileComponent } from './my-profile/my-profile.component';
import { MyPreferenceComponent } from './my-preference/my-preference.component';
import { MyAccountLeftMenuComponent } from './my-account-left-menu/my-account-left-menu.component';
import { MyPaymentHistoryComponent } from './my-payment-history/my-payment-history.component';
import { HowItsWorkComponent } from './how-its-work/how-its-work.component';
//import {TimeAgoPipe} from 'time-ago-pipe';
import { DateAgoPipe } from './pipes/date-ago.pipe';
import { PrivacyPolicyComponent } from './privacy-policy/privacy-policy.component';
import { TermConditionComponent } from './term-condition/term-condition.component';
import { MyInspectionComponent } from './my-inspection/my-inspection.component';
import { InspectionDetailComponent } from './inspection-detail/inspection-detail.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { Ng2ImgMaxModule } from 'ng2-img-max';
import { LiveOkshanLinkComponent } from './live-okshan-link/live-okshan-link.component';
import { PaymentComponent } from './payment/payment.component';
import { AboutComponent } from './about/about.component';
import { About1Component } from './about1/about1.component';
import { PrivacyPolicy1Component } from './privacy-policy1/privacy-policy1.component';
import { TermCondition1Component } from './term-condition1/term-condition1.component';
import { Contactus1Component } from './contactus1/contactus1.component';
import { ShowOffersComponent } from './show-offers/show-offers.component';
import { FixedPriceCarSellerAcceptanceDetailComponent } from './fixed-price-car-seller-acceptance-detail/fixed-price-car-seller-acceptance-detail.component';
import { LiveFpsLinkComponent } from './live-fps-link/live-fps-link.component';

const routes: Routes = [{ path: '', component: VisitorComponent },
{ path: 'home', component: HomeComponent },
{ path: 'sell-car', component: SellCarComponent },
{ path: 'sell-okshan-car', component: SellCarComponent },
{ path: 'visitor', component: VisitorComponent },
{ path: 'visitorview', component: VisitorViewComponent },
{ path: 'visitor-contactus', component: VisitorCantactusComponent },
{ path: 'fixed-price-cars', component: FixedPriceCarsComponent },
//{ path: 'fixed-price-cars-refresh', component: FixedPriceCarsComponent },
{ path: 'auction-cars', component: AuctionCarsComponent },
//{ path: 'auction-cars-refresh', component: AuctionCarsComponent },
{ path: 'fixed-price-car-detail', component: FixedPriceCarDetailComponent },
{ path: 'auction-car-detail', component: AuctionCarDetailComponent },
{ path: 'my-cars', component: MyCarsComponent },
{ path: 'my-profile', component: MyProfileComponent },
{ path: 'my-preference', component: MyPreferenceComponent },
{ path: 'my-payment-history', component: MyPaymentHistoryComponent },
{ path: 'how-its-work', component: HowItsWorkComponent },
{ path: 'privay-policy', component:  PrivacyPolicyComponent},
{ path: 'term-condition', component:  TermConditionComponent},
{ path: 'my-inspection', component:  MyInspectionComponent},
{ path: 'inspection-detail', component:  InspectionDetailComponent},
{ path: 'live-okshan-link', component:  LiveOkshanLinkComponent},
{ path: 'live-fps-link', component:  LiveFpsLinkComponent},
{ path: 'payment', component:  PaymentComponent},
{ path: 'about', component:  AboutComponent},
{ path: 'about1', component:  About1Component},
{ path: 'privacy-policy1', component:  PrivacyPolicy1Component},
{ path: 'term-condition1', component:  TermCondition1Component},
{ path: 'show-offers', component:  ShowOffersComponent},
{ path: 'fixed-price-car-seller-acceptance-detail', component:  FixedPriceCarSellerAcceptanceDetailComponent}
];

@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    HeaderComponent,
    FooterComponent,
    SellCarComponent,
    VisitorComponent,
    VisitorViewComponent,
    VisitorCantactusComponent,
    FixedPriceCarsComponent,
    AuctionCarsComponent,
    FixedPriceCarDetailComponent,
    AuctionCarDetailComponent,
    MyCarsComponent,
    MyProfileComponent,
    MyPreferenceComponent,
    MyAccountLeftMenuComponent,
    MyPaymentHistoryComponent,
    HowItsWorkComponent,
    //TimeAgoPipe,
    DateAgoPipe,
    PrivacyPolicyComponent,
    TermConditionComponent,
    MyInspectionComponent,
    InspectionDetailComponent,
    LiveOkshanLinkComponent,
    PaymentComponent,
    AboutComponent,
    About1Component,
    PrivacyPolicy1Component,
    TermCondition1Component,
    Contactus1Component,
    ShowOffersComponent,  
    FixedPriceCarSellerAcceptanceDetailComponent, LiveFpsLinkComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    RouterModule.forRoot(routes), 
    HttpClientModule,
    StorageServiceModule,
    ReactiveFormsModule,
    FormsModule,
    DeviceDetectorModule.forRoot(),
    NgbModule,
    NgSelectModule,
    Ng2ImgMaxModule    
  ],
  providers: [
    ConstantsService,
    SessionsService,
    UtilsService,
    HttpserviceService,
    {provide: LocationStrategy, useClass: HashLocationStrategy},
    NgxImageCompressService
    ],
  bootstrap: [AppComponent]
})
export class AppModule { }
